import React, { useEffect, useState } from "react";
import ResponsiveTable from "../../../design-system/ResponsiveTable";
import PageToolbar from "../../../design-system/PageToolbar";
import { itemRender, onShowSizeChange } from "../../../commons/PaginationFunction";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import AddDesignations from "./AddDesignations";
import UpdateDesignations from "./UpdateDesignations";

import { useTranslation } from "react-i18next";
const Designations = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const getData = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/designations`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  const getDepartments = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/departments`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          let makeOptions = res.data?.map(d => ({ label: d?.title, value: d?._id }));
          setDepartmentOptions(makeOptions);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/designations/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    getData();
    getDepartments();

    return () => {};
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a._id.length - b._id.length
    },
    {
      title: t("Title"),
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b?.title)
    },
    {
      title: t("Action"),
      key: "action",
      dataIndex: "",
      render: (text, obj) => (
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <UpdateDesignations departments={departmentOptions} data={obj} updateParent={getData} />
          <DeleteModal text="Designations" onClick={() => deleteHandler(obj?._id)} />
        </div>
      )
    }
  ];

  // The shell (PanelsHeader) renders the page title, breadcrumb and navigation.
  return (
    <div className="subadmin-list-page">
      <PageToolbar
        actions={<AddDesignations departments={departmentOptions} updateParent={getData} />}
      />
      <ResponsiveTable
        pagination={{
          total: data.length,
          showTotal: (total, range) =>
            t("pagination.showTotal", { rangeStart: range[0], rangeEnd: range[1], total }),
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          itemRender: itemRender
        }}
        columns={columns}
        dataSource={data}
        rowKey={record => record._id ?? record.id}
      />
    </div>
  );
};

export default Designations;
